/**
 * Maximum width size in pixels that determines what kind of device is being used.
 */
export enum DeviceMaximumWidth {
  Mobile = 768
}
